import ApiService from './ApiService';

class AuthService {

  // ── Admin ──────────────────────────────────────────────

  async login(email, password, otp = null) {
    try {
      const response = await ApiService.request({
        method: 'POST',
        url: '/admin/login',
        data: { email, password, ...(otp && { otp }) },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('admin');
    localStorage.removeItem('permissions');
    window.location.href = process.env.REACT_APP_BASE_PATH + '/admin/login';
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('admin'));
  }

  // ── partner / Partner ──────────────────────────────────

  async partnerLogin(email, password, otp = null) {
    try {
      const response = await ApiService.request({
        method: 'POST',
        url: '/partner/login',
        data: { email, password, ...(otp && { otp }) },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    }
  }

  partnerLogout() {
    localStorage.removeItem('partner');
    window.location.href = process.env.REACT_APP_BASE_PATH + '/partner/login';
  }

  getCurrentpartner() {
    return JSON.parse(localStorage.getItem('partner'));
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
